import { post } from '../libs/Axios';
import BaseFormComponent from '../abstracts/BaseFormComponent';
import SerializeForm from '../utilities/SerializeForm';

export default class ResetPasswordComponent extends BaseFormComponent {
  get Messages() {
    return {};
  }

  get SELECTORS() {
    return {
      form: '.request-password-body',
      successMsg: '.request-password-success',
    };
  }

  get CLASSES() {
    return {
      visible: 'visible',
      hide: 'hide'
    };
  }

  constructor(element) {
    super(element);
    this.handleClick();
  }


  handleClick() {
    this.onSubmit(async (e, action, formButton) => {
      try {
        this.loading(formButton);
        const formData = new SerializeForm(e.currentTarget).getData('object');
        const { data } = await post(action, { ...formData });
        const { success, error } = data;
        if (error) throw new Error(error);
        if (!error) {
          this.$el.querySelector(this.SELECTORS.form).classList.add(this.CLASSES.hide);
          const banner = document.querySelector('.reset-banner');
          const title = banner.querySelector('h1');
          const subtitle = banner.querySelector('p');
          title.innerHTML = title.getAttribute('data-attribute-title-reset');
          subtitle.innerHTML = subtitle.getAttribute('data-attribute-subtitle-reset');
        }
        this.endLoading(formButton);
        return data;
      } catch (error) {
        this.endLoading(formButton);
        console.error(error);
      }
    });
  }
}
